import { z } from 'zod';
import {
  StringComparator,
  NumericComparator,
  DateComparator,
  GeoLocationComparator,
  ListComparator,
  ObjectComparator,
  BrandAffinityComparator,
  IsOneOfComparator,
  CampaignLabelsComparator,
  CampaignComparator,
  MessageTypeComparator,
  RegexComparator,
  DefaultComparator,
} from 'modules/queryBuilder/types';
import { MatchesCatalogComparator } from 'modules/segmentation/types';

export const segmentationComparatorSchema = z.union([
  z.nativeEnum({ ...StringComparator, ...MatchesCatalogComparator }),
  z.nativeEnum({ ...NumericComparator, ...MatchesCatalogComparator }),
  z.nativeEnum({ ...DateComparator, ...MatchesCatalogComparator }),
  z.nativeEnum({ ...GeoLocationComparator, ...MatchesCatalogComparator }),
  z.nativeEnum({ ...ListComparator, ...MatchesCatalogComparator }),
  z.nativeEnum(ObjectComparator),
  z.nativeEnum({ ...BrandAffinityComparator, ...MatchesCatalogComparator }),
  z.nativeEnum(IsOneOfComparator),
  z.nativeEnum({ ...CampaignLabelsComparator, ...MatchesCatalogComparator }),
  z.nativeEnum({ ...CampaignComparator, ...MatchesCatalogComparator }),
  z.nativeEnum({ ...MessageTypeComparator, ...MatchesCatalogComparator }),
  z.nativeEnum(RegexComparator),
  z.nativeEnum(DefaultComparator),
]);
